'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * IE8+ compatible subclassing. See https://babeljs.io/docs/advanced/caveats/
 */

module.exports = function (parent, child) {

    var props;
    var pi;

    var c = child;
    var p = parent;

    if (typeof c === 'function') {
        pi = 2;
    } else {
        if ((typeof p === 'undefined' ? 'undefined' : _typeof(p)) === 'object') {
            c = function c() {
                p.apply(this, arguments);
            };
            pi = 0;
        } else {
            c = p || function () {};
            pi = 1;
        }

        p = typeof this === 'function' ? this : Object;
    }

    props = Array.prototype.slice.call(arguments, pi);

    function Ctor() {
        this.constructor = c;
    }

    Object.assign(c, p); // copy static props

    Ctor.prototype = p.prototype;
    c.prototype = new Ctor();

    Object.assign(c.prototype, Object.assign.apply(Object, [{}].concat(props)));

    return c;
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/class/extend.js
 ** module id = 507
 ** module chunks = 0 1
 **/